import { createActionGroup, props } from '@ngrx/store';
import { ErrorStore, Event } from '@sleipai/sleip-models';

export const EventsActions = createActionGroup({
  source: 'EventsActions',
  events: {
    loadEventsListForHorse: (horseId: string) => ({
      horseId,
    }),
    loadEventsListForHorseSuccess: props<{ events: Event[] }>(),
    loadEventsListForHorseFailure: props<{
      error: ErrorStore | string | null | any;
    }>(),
  },
});
